import React from 'react'
import FormModal from '../../components/form/FormModal'

function Register() {
  return (
    <FormModal />
  )
}

export default Register